
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Plotly } from 'vue-plotly';
import { ChartLoadingStatus } from '@/types';

type PlotlyDataType = Record<
  string,
  string | number | Record<string, string | number> | null
>;

@Component({
  components: {
    Plotly,
  },
})
export default class ChartComponent extends Vue {
  @Prop() readonly chartData!: PlotlyDataType[];
  @Prop() readonly layout!: PlotlyDataType;
  @Prop() readonly chartLoadingStatus!: ChartLoadingStatus;
}
